import React, { useState } from 'react';
import { MultiCategoryBannerStyle } from './styled';
import Image from 'next/image';
import { images } from '../../../Constants/ImageUrls';
import AnchorCoverTag from '../../StoreHomePage/AnchorCoverTag';
import { useRouter } from 'next/router';
import { getSearchParams } from '../../Parenting/common';
import { getRouterLocale } from '../../../Utils/i18Utils/constant';
import { getScreenName } from '../../../Utils/helper';
import { fireEvent } from '../../../Utils/fireEvent';

function MultiCategoryBanner(props) {
  const { data, categoryId, sectionData } = props;
  const router = useRouter();
  const [clickEffect, setClickEffect] = useState(null);
  const singleProduct = sectionData?.items?.length === 1;
  const catWebUrl = singleProduct
    ? sectionData?.items?.[0]?.webUrl
    : data?.webUrl;

  const callbackFunction = (index, deeplinkValue) => {
    setClickEffect('lowOpacity');
    setTimeout(() => {
      router.push(`${catWebUrl}` + getSearchParams(), '', {
        locale: getRouterLocale(router),
      });
      setClickEffect(null);
    }, [300]);
    fireEvent({
      category: 'clicked_card_in_general_screen',
      shape: 'Banner',
      parent: data?.heading,
      section_id: sectionData?._id,
      section_name: sectionData?.itemName,
      screen_name: getScreenName(),
      id: categoryId,
    });
  };
  return (
    <AnchorCoverTag url={catWebUrl} callbackFunction={callbackFunction}>
      <MultiCategoryBannerStyle
        start={data?.sectionBgColorStart || '#f9af73'}
        end={data?.sectionBgColorEnd || '#fff'}
        className={clickEffect}
      >
        <div className="flexStyle">
          <div className="textSection">
            <p className="title">{data?.heading}</p>
            <div className="featureCover">
              {data?.subHeading?.map((feature, index) => {
                return (
                  <div key={'subFeat' + index} className="features">
                    <Image
                      src={
                        'https://images.myloapp.in/NestJsUploads/1707820222495-tick.svg'
                      }
                      loading="lazy"
                      quality={90}
                      alt=""
                      width={12}
                      height={12}
                    ></Image>
                    <p>{feature}</p>
                  </div>
                );
              })}
            </div>
          </div>
          <img src={data?.icon} alt="" />
        </div>
        <div className="whiteCircle">
          <Image
            src={images?.arrowRedForward}
            loading="lazy"
            quality={90}
            alt=""
            width={12}
            height={12}
          ></Image>
        </div>
      </MultiCategoryBannerStyle>
    </AnchorCoverTag>
  );
}

export default MultiCategoryBanner;
